// extracted by mini-css-extract-plugin
export var boxItems = "_8k-1";
export var boxItemsLg = "_8k-2";
export var button = "_8k-7";
export var buttonHoverless = "_8k-9";
export var buttonLg = "_8k-8";
export var filterGroupBox = "_8k-0";
export var icon = "_8k-3";
export var iconSecondary = "_8k-6";
export var iconWrapper = "_8k-4";
export var iconWrapperLg = "_8k-5";
export var truncatedLabel = "_8k-a";